export default __webpack_public_path__ + "static/media/PuntoNaranjaVacio.9c255c43.png";